import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import colorConfigs from "../../configs/colorConfigs";
import { RootState } from "../../Redux/store";
import { RouteType } from "../../routes/config";
import { useTranslation } from "react-i18next"; 

type Props = {
  item: RouteType;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const SidebarItem = ({ item, open, setOpen }: Props) => {
  const { appState } = useSelector((state: RootState) => state.appState);
  const userRole = useSelector((state: any) => state.general.userRol);

  const location = useLocation();
  const { t } = useTranslation("appRoutes");
  const currentPath = location.pathname;
  

  return (
    item.sidebarProps && item.path && (
      !item.allowedRoles || item.allowedRoles.includes(userRole)
    ) ? (
      <ListItemButton
        component={Link}
        onClick={() => { if (!open) setOpen(true); }}
        to={item.path}
        sx={{
          "&:hover": {
            backgroundColor: colorConfigs.sidebar.hoverBg
          },
          backgroundColor: appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
          paddingRight: "0px",
          paddingY: "12px",
          justifyContent: open ? 'initial' : 'center'
        }}
      >
        <ListItemIcon sx={{
          color: colorConfigs.sidebar.color,
          justifyContent: 'center'
        }}>
          {item.sidebarProps.icon && item.sidebarProps.icon}
        </ListItemIcon>
        <ListItemText
          primary={t(item.sidebarProps.displayText)}
          sx={{ opacity: open ? 1 : 0 }}
        />
      </ListItemButton>
    ) : null
  );
};

export default SidebarItem;
